
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const Index = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Si hay usuario autenticado, ir al dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  // Si no hay usuario, ir a la landing
  return <Navigate to="/landing" replace />;
};

export default Index;
